<template>
  <main class="main bgPage" >
    <!-- <NavbarRegister /> -->
    <div v-if="resCol === '6'" class="pa-3" style="background-color: #16163f;color: white;display: flex;padding-right: 70px !important;;padding-left: 70px !important;justify-content: space-between;">
      <div style="display: flex;">
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-email</v-icon>support@betaskthai.com
        </div>
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>089-456-2288
        </div>
        <div>
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>08-1929-3917
        </div>
      </div>
      <div style="display: flex;">
        <div style="background-color: #09a909;background-color: rgb(9, 169, 9);border-radius: 34px;padding: 2px;padding-right: 10px;padding-left: 10px;font-size: 13px;" class="mr-5">
          <v-icon class="iconify" color="white" data-icon="cib:line"></v-icon> ADD FREIND
        </div>
        <v-icon color="white" class="mr-5">mdi-facebook</v-icon>
        <!-- <v-ico >mdi-facebook</v-ico> -->
        <v-icon class="iconify mr-5" data-icon="cib:tiktok"  color="white"></v-icon>
        <v-icon color="white" class="mr-5">mdi-youtube</v-icon>
        <v-icon color="white" class="mr-5">mdi-twitter</v-icon>
      </div>
    </div>
    <Navbar />
    <v-row>
      <v-col :cols="resCol">
        <v-row>
          <v-col cols="12" align="center">
            <div class="pt-7">
              <div
                v-if="resCol === '6'"
                style="display: flex; margin: 0 auto; padding-left: 15px"
              >
                <div style="text-align: center">
                  <v-avatar color="#FFFFFF" size="70">
                    <span class="black--text text-h4">1</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 20px;
                      font-size: 19px;
                      color: #FFFFFF;
                    "
                  >
                    สมัครสมาชิกบริษัท / ร้าน
                  </div>
                </div>
                <hr />
                <div style="text-align: center">
                  <v-avatar color="grey" size="70">
                    <span class="white--text text-h4">2</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 20px;
                      font-size: 19px;
                      color: #FFFFFF;
                    "
                  >
                    สร้างบัญชี Line Official Account
                  </div>
                </div>
                <hr />
                <div style="text-align: center; margin-left: 30px">
                  <v-avatar color="grey" size="70">
                    <span class="white--text text-h4">3</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 20px;
                      font-size: 19px;
                      color: #FFFFFF;
                    "
                  >
                    เข้าสู่ระบบ
                  </div>
                </div>
              </div>
              <div
                v-if="resCol === '12'"
                style="display: flex; margin: 0 auto; width: 300px"
              >
                <div style="text-align: center">
                  <v-avatar color="#1C3879" size="50">
                    <span class="white--text text-h7">1</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 10px;
                      font-size: 14px;
                    "
                  >
                    สมัครสมาชิก
                  </div>
                </div>
                <hr style="margin-top: 20px" />
                <div style="text-align: center">
                  <v-avatar color="grey" size="50">
                    <span class="white--text text-h7">2</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 10px;
                      font-size: 14px;
                    "
                  >
                    สร้าง Line OA
                  </div>
                </div>
                <hr style="margin-top: 20px" />
                <div style="text-align: center; margin-left: 10px">
                  <v-avatar color="grey" size="50">
                    <span class="white--text text-h7">3</span>
                  </v-avatar>
                  <div
                    style="
                      white-space: nowrap;
                      margin-top: 10px;
                      font-size: 14px;
                    "
                  >
                    เข้าสู่ระบบ
                  </div>
                </div>
              </div>
            </div>
            <v-img
              contain
              width="60%"
              :src="require('@/assets/Character_BeLoyalty_01-01.png')"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col :cols="resCol" style="padding: 40px 30px;">
        <div class="pb-15 pt-7 background-login">
          <v-row class="text-center" justify="center" no-gutters>
            <v-col cols="10">
              <h2 style="color: #001d6e">
                <strong>ลงทะเบียนเข้าใช้งาน</strong>
              </h2>
              <h5><strong>กรุณากรอกแบบฟอร์มนี้เพื่อสร้างบัญชี</strong></h5>
            </v-col>
          </v-row>
          <br />
          <v-form ref="form_add" v-model="validAdd" lazy-validation>
            <v-row justify="center" no-gutters style="height:55px">
              <v-col cols="8">
                <v-text-field
                  v-model="form.name"
                  label="ชื่อบริษัท"
                  :rules="[rules.required]"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters style="height: 55px">
              <v-col cols="8">
                <v-text-field
                  v-model="form.contactTel"
                  label="เบอร์ติดต่อ"
                  outlined
                  required
                  dense
                  v-mask="'###-###-####'"
                  maxlength="12"
                  :rules="[rules.required]">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters style="height: 55px">
              <v-col cols="8">
                <v-text-field
                  v-model="form.Email"
                  label="Username"
                  placeholder="Email"
                  :rules="[rules.required, rules.email]"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters style="height: 55px">
              <v-col cols="8">
                 <v-text-field
                  v-model="form.password"
                  label="Password"
                  placeholder="Password"
                  :rules="[rules.required]"
                  outlined
                  dense
                  :append-icon="show ? 'mdi-eye-remove' : 'mdi-eye-check'"
                    :type="type"
                    @click:append="showPass"
                ></v-text-field>

              </v-col>
            </v-row>

            <v-row justify="center" no-gutters style="height: 70px;">
              <v-col cols="8" style="display: flex; justify-content: center">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="verifyMethod"
                  @render="renderMethod"
                  sitekey="6Lef5A8hAAAAAIffpLLp_mpt_UFbcuq6l_mXbh8e"
                ></vue-recaptcha>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters style="display: contents;">
              <v-col cols="12" style="justify-content: center;display: flex;height: 46px;">
                <v-checkbox hide-details v-model="checkTerm1" @change="closeDialogPDPA()" style="margin-bottom: 10px;" color="primary">
                  <template v-slot:label>
                    <div style="align-items: center;display: flex;padding-top: 6px;">
                      ยอมรับ
                    </div>
                  </template>
                </v-checkbox>
                <a  @click = "openPrivacyNotice(1)" href="#"
                    :style="widthScreen <= 375 ? 'margin-left: 6px;display: flex;align-items: end;margin-top: 48px;text-decoration: revert;' : 'margin-left: 6px;display: flex;align-items: end;margin-top: 48px;text-decoration: revert;'">
                  นโยบายความเป็นส่วนตัวสำหรับลูกค้า
                </a>
              </v-col>
              <v-col cols="12" :style="widthScreen <= 375 ? 'justify-content: center;display: flex;margin-top: 10px;left: -10px;' : 'justify-content: center;display: flex;left: -10px;'">
                <v-checkbox hide-details v-model="checkTerm2" @change="closeDialogPDPA()" style="margin-bottom: 10px;" color="primary">
                  <template v-slot:label>
                    <div style="align-items: center;display: flex;padding-top: 6px;">
                      ยอมรับ
                    </div>
                  </template>
                </v-checkbox>
                <a  @click = "openPrivacyNotice(2)" href="#"
                    :style="widthScreen <= 375 ? 'margin-left: 6px;display: flex;align-items: center;text-decoration: revert;margin-top:7px;' : 'margin-left: 6px;display: flex;align-items: center;text-decoration: revert;margin-top: 5px;'">
                  ข้อกำหนดและเงื่อนไขการใช้บริการ
                </a>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutter v-show="!checkTerm1 || !checkTerm2">
              <v-col cols="12" :style="widthScreen <= 375 ? 'justify-content: center;display: flex;color:red;font-size:15px;' : 'justify-content: center;display: flex;color:red;'">
                กรุณากรอกเลือกยอมรับ ข้อกำหนดและเงื่อนไขการใช้บริการ
              </v-col>
            </v-row>
            <v-row
              v-if="recapStatus"
              justify="center"
              no-gutters
              style="height: 55px"
            >
              <v-col cols="8">
                <v-alert text outlined type="error">
                  กรุณากดยืนยันตัว.
                </v-alert>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutter >
              <v-col cols="8">
                <v-btn
                  color="#001D6E"
                  style="font-size: 20px"
                  dark
                  x-large
                  block
                  :disabled="!checkTerm1 || !checkTerm2 || recapchaToken === '' "
                  @click="addData()"
                >
                  ยืนยันการลงทะเบียน
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutter>
              <div class="mr-2" style="font-size: 18px">มีบัญชีอยู่แล้ว?</div>
              <a href="gotoLogin()" style="padding: 3px;">เข้าสู่ระบบ</a>
              <!-- <div style="font-size: 18px; color: #001d6e" @click="gotoLogin()">
                เข้าสู่ระบบ
              </div> -->
            </v-row>
          </v-form>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogEnd" persistent max-width="445">
      <v-card>
        <v-container>
          <v-card-text>
            <v-row class="mb-6" justify="center">
              <v-col md="auto">
                <v-img
                  src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FnotiUser.png?alt=media&token=f4d142cd-3e4c-4b7c-831e-2fae4008fe67"
                  class="a"
                  style="width: 353px; height: 216.51px"
                ></v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row class="mb-6" justify="center">
              <v-col md="auto">
                <h3 style="color: black"><strong>Important !!</strong></h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row class="mb-6" justify="center" no-gutters>
              <v-col lg="8">
                <h6><strong>Username:</strong>{{ form.email }}</h6>
                <h6><strong>Password:</strong>1234</h6>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row justify="center" no-gutter>
            <v-col md="auto">
              <v-btn
                dark
                x-large
                color="#1B437C"
                @click="
                  (dialogEnd = false),
                    checkboot()
                "
              >
                ไปหน้าถัดไป
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </main>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment-timezone'
import Navbar from '../Core/Navbar.vue'
// import PrivacyNotice from '../Welcome/PrivacyNotice.vue'
// import NavbarRegister from '../Welcome/NavbarRegister.vue'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    name: '',
    // PrivacyNotice,
    // NavbarRegister,
    'vue-recaptcha': VueRecaptcha,
    Navbar
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    }
  },
  data () {
    return {
      checkTerm1: false,
      checkTerm2: false,

      checkbo1: false,
      checkbox2: false,
      vShow: false,
      dialogPrivacyNotice: true,
      overlay: false,
      recapStatus: false,
      show: '',
      type: 'password',
      form: {
        userEmail: '',
        userCode: '',
        Email: '',
        contactTel: '',
        name: '',
        userName: '',
        password: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        userCreate: '',
        flexPicHomePage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.03.png?alt=media&token=550c3714-fa10-4ea8-b46d-527e7c5d4792',
        flexPicMembercardPage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.58.png?alt=media&token=6695dd3b-9f4f-4d6f-a3e0-a0ebf5de105b'
      },
      category: [],
      Allcategory: [],
      categorySub: [],
      AllcategorySub: [],
      rules: {
        required: (value) => !!value || 'กรุณากรอก.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'กรุณากรอก e-mail.'
        }
      },
      recapchaToken: '',
      shopIdGoto: '',
      shopId: '',
      dataReady: true,
      validAdd: true,
      dialog: false,
      dialogEnd: false,
      privacyConfigDetail:
        '<h6 class="ql-align-center">เรื่อง นโยบายความเป็นส่วนตัว</h6><p class="ql-align-center"><br></p><p class="ql-align-center">บริษัท บีแทสก์ คอนซัลติ้ง จำกัด เห็นความสำคัญ ในการปกป้องข้อมูลส่วนบุคคล  เพื่อเป็นให้เป็นไปตาม<a href="http://www.ratchakitcha.soc.go.th/DATA/PDF/2562/A/069/T_0052.PDF" rel="noopener noreferrer" target="_blank" style="color: rgb(0, 123, 255);">พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</a></p><hr class="ql-align-center"><p class="ql-align-center">ผู้ให้บริการให้มี สิทธิการเข้าถึงข้อมูล <code style="color: rgb(232, 62, 140);">(Personal Data Protection Act : PDPA)</code></p><hr><p><strong><u>สำคัญ</u></strong></p><ol><li>ในการใช้บริการนี้ ผู้ใช้ต้องตรวจสอบว่าได้ดำเนินการผ่าน V-LINK ผู้ให้บริการนี้ไม่ ต้องรับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากการใช้บริการจาก แหล่งอื่นที่ไม่ใช่ผู้ให้บริการอย่างเป็นทางการ</li><li>ข้อมูลส่วนบุคคลที่มอบให้แก่บริการนี้และข้อมูลส่วนบุคคลที่ รวบรวมใหม่จะถูกนำไปใช้ภายใต้ความรับผิดชอบของผู้ใช้บริการ นี้ โปรดตรวจสอบรายละเอียดในข้อกำหนดการใช้บริการและ นโยบายความเป็นส่วนตัวของผู้ให้บริการ</li><li>ข้อมูลโปรไฟล์ประกอบด้วย ชื่อ-นามสกุล,วันเกิด ,อีเมลล์</li><li>โปรดตรวจสอบว่า ชื่อ-นามสกุลของท่าน ไม่มีเนื้อหาที่ละเมิดในสิทธิ์ของผู้ใด เช่น ละเมิดลิขสิทธิ์ ละเมิด ความเป็นส่วนตัว ตามที่ระบุในข้อกำหนดการใช้บริการ บริษัท บีแทสก์ คอนซัลติ้ง จำกัด</li></ol><p><br></p>'
    }
  },
  async mounted () {
    console.log(moment().add(7, 'days').format('YYYY-MM-DD'))
  },
  methods: {
    showPass () {
      if (this.type === 'password') {
        this.type = 'text'
        this.show = '1'
        console.log(this.type, this.show)
      } else {
        this.type = 'password'
        this.show = ''
        console.log(this.type, this.show)
      }
    },
    gotoLogin () {
      window.location.href = 'https://betask-loyalty-app.web.app/'
    },
    validate () {
      this.$refs.form_add.validate()
    },
    verifyMethod (a) {
      this.recapchaToken = a
      this.recapStatus = false
    },
    renderMethod (c) {
      console.log(c)
    },
    checkboot () {
      // if (this.$route.query.ref === 'boot') {
      //   window.location = 'https://betask-loyalty-app.web.app/'
      // } else {
      console.log('a')
      // window.location = 'http://localhost:8081/System/CreateLineOAaccount?shopId=' + this.form.shopId
      this.$router.push('/System/CreateLineOAaccount?shopId=' + this.form.shopId)
      console.log('f')
      // }
    },
    async addData () {
      console.log(moment())
      if (this.$refs.form_add.validate() === true) {
        if (this.form.Email) {
          axios
            .get(this.DNS_IP + '/system_user/get?userName=' + this.form.Email)
            .then(res => {
              if (res.data.status === false) {
                this.$swal({
                  title: 'ต้องการ ลงทะเบียน ใช่หรือไม่?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: 'ใช่',
                  cancelButtonText: 'ไม่'
                })
                  .then(async (result) => {
                    this.form.CREATE_USER = 'System Create'
                    this.form.LAST_USER = 'System Create'
                    this.form.userCreate = 'System Create'
                    this.form.shopId = 'SD_' + moment().valueOf()
                    this.form.userCode = 'SYS_USER_' + moment().valueOf()
                    this.form.expire_date_trial = moment().add(7, 'days').format('YYYY-MM-DD')
                    // this.form.productName = this.$route.query.productName
                    // this.form.userEmail = this.form.Email
                    console.log('form', this.form)
                    await axios
                      .post(
                        this.DNS_IP + '/system_shop/createShop',
                        this.form
                      )
                      .then(async (response) => {
                        this.$swal('เรียบร้อย', 'สร้างร้าน เรียบร้อย', 'success')
                        console.log('response', response.data)
                        this.checkboot()
                      })
                  })
              } else {
                this.$swal('ไม่สำเร็จ', 'Username ถูกใช้งานแล้ว', 'error')
                this.form.Email = ''
              }
            // this.checkboot()
            })
        }
      } else {
        this.$swal(
          '',
          'กรุณากรอกข้อมูลให้ครบถ้วน',
          'warning'
        )
      }
    }
  }
}
</script>
<style scoped>
.main {
  /* padding: 0px; */
  background: #ffffff;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
}
/* .bgPage {
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
} */
hr {
  border: none;
  /* border-top: 4px dotted grey; */
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 50%;
  margin-top: 30px;
}
.bgPage {
  background: url("../../assets/bg.png");
  height: 100%;
  /* left: 0%;
        right: 0%;
        top: 0%;
        bottom: 0%; */
}
.background-login {
  background-color: #ffffffcc;
  padding: 10px;
  border-radius: 40px;
  opacity: 1;
  max-width: 800px
}
.v-label  {
    /* color: rgba(0,0,0,.6); */
    margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/System/Register.vue